import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SearchCommand } from "./SearchCommand";
import { useAuth } from "@/hooks/useAuth";
import { 
  Search, 
  BookOpen, 
  Map, 
  User, 
  LogIn,
  X
} from "lucide-react";

interface MobileNavProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MobileNav = ({ open, onOpenChange }: MobileNavProps) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const { user } = useAuth();

  const closeMenu = () => onOpenChange(false);

  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40 lg:hidden" 
        onClick={closeMenu}
      />
      
      {/* Mobile Menu */}
      <div className="fixed top-0 left-0 right-0 bg-background border-b shadow-lg z-50 lg:hidden">
        <div className="container mx-auto px-4 py-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <Link to="/" className="text-xl font-bold" onClick={closeMenu}>
              The Academy
            </Link>
            <Button variant="ghost" size="sm" onClick={closeMenu}>
              <X className="h-4 w-4" />
            </Button>
          </div>

          {/* Navigation Links */}
          <div className="space-y-4">
            <Link 
              to="/" 
              className="flex items-center space-x-3 p-3 rounded-lg hover:bg-muted transition-colors"
              onClick={closeMenu}
            >
              <BookOpen className="h-5 w-5" />
              <span className="font-medium">Disciplines</span>
            </Link>

            <Link 
              to="/search" 
              className="flex items-center space-x-3 p-3 rounded-lg hover:bg-muted transition-colors"
              onClick={closeMenu}
            >
              <Search className="h-5 w-5" />
              <span className="font-medium">Search</span>
            </Link>

            <Link 
              to="/convergence" 
              className="flex items-center space-x-3 p-3 rounded-lg hover:bg-muted transition-colors"
              onClick={closeMenu}
            >
              <BookOpen className="h-5 w-5" />
              <span className="font-medium">Convergence</span>
            </Link>

            {/* Auth Section */}
            <div className="border-t pt-4 mt-4">
              {user ? (
                <Link 
                  to="/profile" 
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-muted transition-colors"
                  onClick={closeMenu}
                >
                  <User className="h-5 w-5" />
                  <span className="font-medium">Profile</span>
                </Link>
              ) : (
                <div className="space-y-2">
                  <Button variant="outline" className="w-full justify-start" asChild>
                    <Link to="/auth/login" onClick={closeMenu}>
                      <LogIn className="h-4 w-4 mr-2" />
                      Sign In
                    </Link>
                  </Button>
                  <Button className="w-full" asChild>
                    <Link to="/auth/signup" onClick={closeMenu}>
                      Sign Up
                    </Link>
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Search Command */}
      <SearchCommand open={searchOpen} onOpenChange={setSearchOpen} />
    </>
  );
};
